<template>
    <div class="d-flex flex-row align-items-center justify-content-start">
        <p class="dv-card-title font-size-20 ml-1">安全生产</p>
        <div class="date-card" :key="i" v-for="(num,i) in daysArray">
            <p class="date-card-number">{{ num }}</p>
        </div>
        <p class="dv-card-title font-size-20">天</p>

        <p class="ml-auto p-2 dv-card-title font-size-14">自</p>
        <p class="dv-card-title font-size-16 color-blue">{{ safetyDateFrom }}</p>
        <p class="dv-card-title p-2 font-size-14">至</p>
        <p class="dv-card-title font-size-16 color-blue">{{ datetime.substring(0, 11) }}</p>
        <p class="dv-card-title p-2 font-size-16">{{ datetime.substring(11, 19) }}</p>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "SafetyDays",
    props: {
        safetyDateFrom: {
            type: String,
            required: true
        }
    },
    computed: {
        daysArray() {
            let time_cal = (new Date().getTime() - new Date(this.safetyDateFrom).getTime()) / (3600 * 1000 * 24) - 1
            let safetyDays = [];
            while (time_cal >= 1) {
                time_cal = Math.floor(time_cal)
                safetyDays.push(time_cal % 10);
                time_cal /= 10
            }
            safetyDays.reverse();
            return safetyDays;
        }
    },
    data() {
        return {
            datetime: '',
            refresh: null
        }
    },
    mounted() {
        this.refresh = setInterval(() => {
            this.datetime = moment(new Date()).format(this.$t("em.datetime.format.viewMode"))
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.refresh);
    }
}
</script>

<style scoped>
.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.font-size-20 {
    font-size: 2rem !important;
}

.font-size-16 {
    font-size: 1.6rem !important;
}

.font-size-14 {
    font-size: 1.4rem !important;
}

.color-blue {
    color: #08e5ff !important;
}

.date-card {
    background-color: rgba(4, 49, 128, .6);
    height: 5.5rem;
    width: 5.5rem;
    margin: auto;
    padding: 0
}

.date-card-number {
    color: #08e5ff;
    font-size: 2.8rem;
    font-weight: bold;
    text-align: center;
    margin: 0.5rem
}
</style>